import { UserAccountState } from ".";

export const UserAccountStateOrders: Record<UserAccountState, number> = {
    Draft: 0,
    EmailNotVerified: 1,
    EmailNotVerifiedWrongAttempt: 1,
    Active: 2,
    Canceled: 3
} 